import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';
import styles from './index.module.css';

const UpdateYourLookPage = () => {
  const { find, meta } = usePageContent('update-your-look');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Update your look');
  useMeta(seo);
  const c = find('richText') || {};

  return (
    <div id="content">
      <div className="page-header">
        <div className="page-header__content">
          <h1 className="page-header__title">{c.pageTitle || 'Update your look'}</h1>
        </div>
      </div>
      <div className="content-holder">
        <div
          className={`rich-text ${styles.wrapper}`}
          dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }}
        />
      </div>
    </div>
  );
};

export default UpdateYourLookPage;
